import { Collection } from 'modules/core/lib/mobx-rest'

import ApprovalGroup from 'modules/approvals/store/models/ApprovalGroup'

class ApprovalGroups extends Collection<ApprovalGroup> {
  get cacheKey(): string {
    return 'approvalGroups'
  }

  model() {
    return ApprovalGroup
  }
}

const singleton: ApprovalGroups = new ApprovalGroups()

export default singleton
